module.exports = __webpack_public_path__ + "static/media/cloud-computing.f408d819.svg";